var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrivingRangeDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    height: 202.604,
    viewBox: "0 0 250 202.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20088",
    "data-name": "Rectangle 20088",
    width: 215.965,
    height: 200.794,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4128",
    "data-name": "Group 4128",
    transform: "translate(13250 21653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20121",
    "data-name": "Rectangle 20121",
    width: 250,
    height: 200,
    transform: "translate(-13250 -21653)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4092",
    "data-name": "Group 4092",
    transform: "translate(-13232.982 -21651.189)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4900",
    "data-name": "Path 4900",
    d: "M184.128,19.4c-1.026-5.187-7.173-8.813-15.35-8.813H138.659V21.155h30.119a11.345,11.345,0,0,1,4.942.971l30.666,59.959a12.939,12.939,0,0,1-3.915.558H15.506a12.605,12.605,0,0,1-4.161-.558L32.35,31.7l-9.739-4.061L.413,80.813,0,82.843c0,6.024,6.526,10.4,15.506,10.4H200.47c8.924,0,15.506-4.373,15.506-10.4V81.56Z",
    transform: "translate(0 107.554)",
    fill: "#d2d5da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4901",
    "data-name": "Path 4901",
    d: "M20.6,129.624V127.46a7.608,7.608,0,0,0,2.934.6,7.987,7.987,0,0,0,7.92-7.931q-2.376-29.383-4.741-58.788c-.19-2.3-.379-4.607-.558-6.905q2.7-5.477,5.41-10.954,1.249,8.11,2.532,16.22L35.134,66.4a7.987,7.987,0,0,0,9.75,5.578,7.44,7.44,0,0,0,1.707-.87l42.669,59.39c-.067.29-.29.547-.29.837,0,3.659,5.165,6.626,11.535,6.626s11.534-2.967,11.534-6.626-5.165-6.615-11.534-6.615a16.733,16.733,0,0,0-7.641,1.74L50.071,66.787a10.274,10.274,0,0,0,.4-4.607q-3.681-23.56-7.351-47.142L42.072,8.344a6.28,6.28,0,0,0-3.045-4.217c-.223-.156-.346-.379-.591-.513a7.463,7.463,0,0,0-1.417-.435,8.121,8.121,0,0,0-4.685-.368,9.292,9.292,0,0,0-.881.446,6.582,6.582,0,0,0-3.86,3.2L8.629,45.168,5.941,50.656a.214.214,0,0,1-.067.19A7.541,7.541,0,0,0,5.093,53.5v.178a6.694,6.694,0,0,0-.2.982v74.963a7.92,7.92,0,1,0,15.84,0",
    transform: "translate(49.679 26.649)",
    fill: "#d2d5da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4902",
    "data-name": "Path 4902",
    d: "M20.808,26.951a13.475,13.475,0,1,0-9.557-3.931,13.476,13.476,0,0,0,9.557,3.931",
    transform: "translate(74.011 0)",
    fill: "#d2d5da"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivingRangeDefault);
export default __webpack_public_path__ + "static/media/driving-range-default.36206f47432b2a2e8d5546d9b775dbf8.svg";
export { ForwardRef as ReactComponent };